import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './tag-form-loading.style';

export const TagFormLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
